export const ChatServiceEndpoints = {
    sendMessage: () => `/ai/chat`,
}
